import type { ReactNode } from "react"
import React from "react"

import type { PopoverProps } from "@chakra-ui/react"
import {
  Button,
  ButtonGroup,
  Popover,
  PopoverAnchor,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
} from "@chakra-ui/react"

interface Props extends PopoverProps {
  onSubmit: () => void
  onCancel?: () => void
  proceedButtonLabel?: string
  cancelButtonLabel?: string
  inProgress?: boolean
  text?: ReactNode
  title?: string
  children?: ReactNode
  triggerRef?: React.RefObject<HTMLDivElement>
}

export const Confirmation = ({
  triggerRef,
  title,
  text,
  onSubmit,
  onClose,
  onCancel,
  inProgress,
  cancelButtonLabel,
  proceedButtonLabel,
  ...props
}: Props) => {
  return (
    <Popover onClose={onClose} {...props}>
      {triggerRef ? (
        <PopoverAnchor>
          <div ref={triggerRef} style={{ height: 0 }} />
        </PopoverAnchor>
      ) : (
        props.children && <PopoverTrigger>{props.children}</PopoverTrigger>
      )}

      <PopoverContent zIndex={4} onClick={(event) => event.stopPropagation()}>
        {title && (
          <PopoverHeader fontWeight="semibold" pr={10}>
            {title}
          </PopoverHeader>
        )}

        <PopoverArrow />

        <PopoverCloseButton />

        {text && (
          <PopoverBody
            whiteSpace="normal"
            pr={title ? undefined : 10}
            pt={title ? undefined : 10}
          >
            {text}
          </PopoverBody>
        )}

        <PopoverFooter border={0} display="flex" justifyContent="flex-end">
          <ButtonGroup size="sm">
            <Button
              variant="ghost"
              colorScheme="secondary"
              color="neutrals.700"
              onClick={onCancel || onClose}
            >
              {cancelButtonLabel || "Cancel"}
            </Button>

            <Button
              colorScheme="red"
              onClick={onSubmit}
              isDisabled={inProgress}
            >
              {proceedButtonLabel || "Proceed"}
            </Button>
          </ButtonGroup>
        </PopoverFooter>
      </PopoverContent>
    </Popover>
  )
}
